import * as React from 'react';
import { getFacts } from '../../selectors/developerV2/getFacts';
import { useSelector } from 'react-redux';
import { FactsWrapper, Fact } from '../../components/Facts';
import { getMarkedList } from '../../selectors/developerV2';
import { MarkedList, MarkedListItem } from '../../components/MarkedListItem';
import { getPromoColor } from '../../selectors/developerV2/getPromoColor';

export const Facts = () => {
  const facts = useSelector(getFacts);
  const markedList = useSelector(getMarkedList);
  const promoColor = useSelector(getPromoColor);

  return (
    <>
      <MarkedList>
        {markedList && markedList.map((item, index) => <MarkedListItem text={item} key={index} />)}
      </MarkedList>
      {!!facts.length && (
        <FactsWrapper>
          {facts.map((fact, index) => (
            <Fact
              promoColor={promoColor}
              key={index}
              title={fact.title}
              text={fact.text}
              type={fact.type}
              description={fact.description}
            />
          ))}
        </FactsWrapper>
      )}
    </>
  );
};
